(function () {
  if (window.__awInit) return;
  window.__awInit = true;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.aw-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window === false) {
      els.forEach(function (el) { el.classList.add('aw-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aw-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initEscenario(root) {
    var wrap = (root || document).querySelector('[data-aw-escenario]');
    if (!wrap || wrap.dataset.awInit) return;
    wrap.dataset.awInit = '1';
    var btns = wrap.querySelectorAll('[data-aw-esc-btn]');
    var panels = wrap.querySelectorAll('[data-aw-esc-panel]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.awEscBtn;
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.awEscPanel === target);
        });
      });
    });
  }

  function initFaq(root) {
    var items = (root || document).querySelectorAll('[data-aw-faq-item]');
    items.forEach(function (item) {
      if (item.dataset.awInit) return;
      item.dataset.awInit = '1';
      var btn = item.querySelector('[data-aw-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
  }

  function initMosaico(root) {
    var cells = (root || document).querySelectorAll('[data-aw-mosaico-cell]');
    cells.forEach(function (cell) {
      if (cell.dataset.awInit) return;
      cell.dataset.awInit = '1';
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.nodeType === 1) ? e.target : document;
    initReveal(root);
    initEscenario(root);
    initFaq(root);
    initMosaico(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  document.addEventListener('shopify:section:load', initTodo);
})();
